import { ArrowLeft } from 'lucide-react';

import { useNavigate } from 'react-router';
import { FormUnsaveChangeGuard } from '../form-unsave-change-guard';

interface FormBackHeaderProps {
  title?: string;
}

function FormBackHeader({ title }: Readonly<FormBackHeaderProps>) {
  const navigate = useNavigate();

  return (
    <>
      <button
        type="button"
        className="text-text-secondary flex h-full cursor-pointer items-center gap-2 text-sm"
        onClick={() => navigate(-1)}
      >
        <ArrowLeft className="size-4" />
        <h5>{title}</h5>
      </button>

      <FormUnsaveChangeGuard />
    </>
  );
}

export { FormBackHeader };
